<div class="header-container top-container flex-col">
  <app-mladmin-info class="w-full" />
  @if (currentUserService.currentUserValue?.repairerSites?.length) {
    <app-mladmin-repairer-sites class="w-full my-25" />
  }
</div>
